// extracted by mini-css-extract-plugin
export default {"root":"Attachments_root__RdgNs","error":"Attachments_error__+h7av"};